import { createFileRoute } from '@tanstack/react-router';
import { ConversionManagement } from '@/components/settings/conversion-management';
import { BarChart } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/_layout/settings/_layout/conversions')({
  component: ConversionsSettings,
  staticData: {
    title: 'Conversion Tracking',
    icon: BarChart,
  },
});

function ConversionsSettings() {
  return <ConversionManagement />;
}
